import { Component, OnInit } from "@angular/core";
import { EvaluationsService } from "../../../services/evaluations.service";
import { AlertService } from "../../../services/alert.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { Router } from "@angular/router";

@Component({
  selector: "app-club-evaluation-staff",
  templateUrl: "./club-evaluation-staff.component.html",
  styleUrls: ["./club-evaluation-staff.component.css"]
})
export class ClubEvaluationStaffComponent implements OnInit {
  clubID: any;
  allStaff: any;
  showStaffAssignedPlayers: boolean = false;
  assignedPlayers: any;

  constructor(
    private _service: EvaluationsService,
    private _router: Router,
    private _alertService: AlertService,
    private _loadingService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    this.clubID = +localStorage.getItem("clubId");
    // this.loadEvaluationStaffMembers(this.clubID);
  }

  showStaffPlayers(staffID) {
    console.log("STAFF ID => ", staffID);
    this._router.navigate(["staff/" + staffID + "/evaluation-check"]);
  }

  loadEvaluationStaffMembers(clubID) {
    this._loadingService.show();
    this._service.getEvaluationStaffByClubID(clubID).subscribe(
      data => {
        this.allStaff = data;
        this._loadingService.hide();
        console.log("ALL STAFF => ", this.allStaff);
      },
      error => {
        this._loadingService.hide();
        console.log("Evaluation Staff ERROR = ", error);
        this._alertService.error(
          "Evaluation staff members could not be loaded"
        );
      }
    );
  }

  onShowStaffAssignedPlayers(staffID) {
    console.log("STAFF ID = ", staffID);
    this._loadingService.show();
    this._service.loadEvaluationsByStaffID(staffID, this.clubID).subscribe(
      (result: any) => {
        this.showStaffAssignedPlayers = true;
        console.log("DATA = ", result.data);
        this.assignedPlayers = result.data;
        this._loadingService.hide();
      },
      error => {
        this.showStaffAssignedPlayers = false;
        this._loadingService.hide();
        this._alertService.error("Players could not be loaded");
      }
    );
  }

  onCancel(event) {
    this.showStaffAssignedPlayers = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/club-evaluations/staff/club-evaluation-staff.component.ts